import { countriesObj } from '../data/countries'

const buildCountriesOptions = () => {
  return Object.keys(countriesObj).map((key) => ({
    value: key,
    label: countriesObj[key]
  }))
}

export { buildCountriesOptions }
